import { useExportContext } from './useExportScheduleContext';

export const useExportSchedule = () => {
  const { startExportSchedule, status } = useExportContext();

  return {
    startExport: startExportSchedule,
    status,
  };
};
